import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=75c8eeb3&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=tsx&"
export * from "./Index.vue?vue&type=script&lang=tsx&"
import style0 from "./Index.vue?vue&type=style&index=0&id=75c8eeb3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c8eeb3",
  null
  
)

export default component.exports